import { render, staticRenderFns } from "./ElementConfigurableScaleTableColumn.vue?vue&type=template&id=4643c51d&scoped=true"
import script from "./ElementConfigurableScaleTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementConfigurableScaleTableColumn.vue?vue&type=script&lang=js"
import style0 from "./ElementConfigurableScaleTableColumn.vue?vue&type=style&index=0&id=4643c51d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4643c51d",
  null
  
)

export default component.exports